import { render, staticRenderFns } from "./feeDetailHis.vue?vue&type=template&id=2114e9b1"
import script from "./feeDetailHis.vue?vue&type=script&lang=js"
export * from "./feeDetailHis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports